var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Jewel100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ec71ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#876bdb"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e699a",
    d: "M 45.5,5.5 C 57.1714,5.33347 68.8381,5.50014 80.5,6C 81.3081,6.30762 81.9747,6.80762 82.5,7.5C 85.9904,34.052 88.1571,60.7187 89,87.5C 88.5,88 88,88.5 87.5,89C 63.1398,88.0537 38.8065,86.387 14.5,84C 11.5488,83.904 8.88217,83.0707 6.5,81.5C 5.35417,69.546 5.1875,57.546 6,45.5C 18.6999,31.6339 31.8665,18.3006 45.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac608a",
    d: "M 46.5,9.5 C 56.6742,8.17682 67.0075,8.17682 77.5,9.5C 77.3764,10.1067 77.0431,10.44 76.5,10.5C 67.3483,9.50644 58.015,9.17311 48.5,9.5C 47.8333,9.5 47.1667,9.5 46.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#light-pink-gradient)",
    d: "M 46.5,9.5 C 47.1667,9.5 47.8333,9.5 48.5,9.5C 49.1667,10.1667 49.8333,10.8333 50.5,11.5C 48.7748,11.8425 48.2748,12.8425 49,14.5C 52.796,18.4494 55.9626,22.7827 58.5,27.5C 57.8333,27.5 57.1667,27.5 56.5,27.5C 55.3784,26.8442 54.0451,26.5108 52.5,26.5C 50.6672,26.5854 49.3339,27.2521 48.5,28.5C 46.9582,27.6993 45.2915,27.366 43.5,27.5C 43.5,26.8333 43.1667,26.5 42.5,26.5C 38.5,25.8333 34.5,25.1667 30.5,24.5C 35.8333,19.5 41.1667,14.5 46.5,9.5 Z M 48.5,9.5 C 58.015,9.17311 67.3483,9.50644 76.5,10.5C 71.5203,15.1449 66.5203,19.8116 61.5,24.5C 57.5879,20.3211 53.9213,15.9878 50.5,11.5C 49.8333,10.8333 49.1667,10.1667 48.5,9.5 Z M 79.5,11.5 C 80.7563,14.1711 80.4229,16.8377 78.5,19.5C 79.8632,21.7075 81.0299,24.0408 82,26.5C 83.6673,44.5042 85.0006,62.5042 86,80.5C 78.7752,63.0501 71.2752,45.7168 63.5,28.5C 68.855,22.813 74.1883,17.1463 79.5,11.5 Z M 43.5,27.5 C 45.2915,27.366 46.9582,27.6993 48.5,28.5C 49.4486,29.1524 50.6153,29.4857 52,29.5C 54.0081,29.6932 55.5081,29.0265 56.5,27.5C 57.1667,27.5 57.8333,27.5 58.5,27.5C 48.8547,37.4794 39.188,47.4794 29.5,57.5C 28.5186,48.1859 27.852,38.8526 27.5,29.5C 32.5111,29.6659 37.5111,29.4993 42.5,29C 43.056,28.6174 43.3893,28.1174 43.5,27.5 Z M 60.5,30.5 C 68.1431,47.732 75.8097,65.0653 83.5,82.5C 83.1667,82.8333 82.8333,83.1667 82.5,83.5C 65.2832,75.7248 47.9499,68.2248 30.5,61C 40.7022,50.9651 50.7022,40.7984 60.5,30.5 Z M 10.5,76.5 C 9.16667,67.8333 9.16667,59.1667 10.5,50.5C 11.8195,51.9418 13.4862,52.6085 15.5,52.5C 15.6495,51.448 15.4828,50.448 15,49.5C 13.0283,48.6948 11.5283,47.3615 10.5,45.5C 14.8333,40.8333 19.1667,36.1667 23.5,31.5C 25.3298,41.4296 25.8298,51.4296 25,61.5C 19.9635,66.3687 15.1302,71.3687 10.5,76.5 Z M 10.5,50.5 C 9.16667,59.1667 9.16667,67.8333 10.5,76.5C 10.44,77.0431 10.1067,77.3764 9.5,77.5C 8.16667,68.1667 8.16667,58.8333 9.5,49.5C 10.1067,49.6236 10.44,49.9569 10.5,50.5 Z M 27.5,63.5 C 45.2652,70.7017 62.9318,78.2017 80.5,86C 60.8197,84.8322 41.153,83.1655 21.5,81C 19.4708,78.1251 17.1374,77.9584 14.5,80.5C 13.5,80.3333 12.5,80.1667 11.5,80C 17.0363,74.6314 22.3697,69.1314 27.5,63.5 Z"
  })), "\ns", "\ns", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#976b9c",
    d: "M 72.5,23.5 C 75.8333,23.5 77.5,25.1667 77.5,28.5C 74.1667,28.5 72.5,26.8333 72.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b06695",
    d: "M 30.5,24.5 C 34.5,25.1667 38.5,25.8333 42.5,26.5C 38.1161,26.8256 33.7828,26.4922 29.5,25.5C 29.6236,24.8933 29.9569,24.56 30.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#976d9e",
    d: "M 56.5,27.5 C 55.5081,29.0265 54.0081,29.6932 52,29.5C 50.6153,29.4857 49.4486,29.1524 48.5,28.5C 49.3339,27.2521 50.6672,26.5854 52.5,26.5C 54.0451,26.5108 55.3784,26.8442 56.5,27.5 Z"
  })), "\ns", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#976b9d",
    d: "M 67.5,29.5 C 70.5242,29.3642 72.0242,30.6975 72,33.5C 68.9784,34.3311 67.4784,32.9978 67.5,29.5 Z"
  })), "\ns", "\ns", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d6e9e",
    d: "M 55.5,40.5 C 59.0289,39.8894 60.8622,41.2227 61,44.5C 58.0753,45.1197 56.2419,43.7864 55.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#956d9e",
    d: "M 50.5,45.5 C 52.9732,45.736 54.6399,47.0693 55.5,49.5C 52.2125,50.5683 50.5458,49.2349 50.5,45.5 Z"
  })), "\ns", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#986d9e",
    d: "M 44.5,51.5 C 47.4598,51.6621 49.2931,52.9954 50,55.5C 47.0753,56.1197 45.2419,54.7864 44.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#976fa0",
    d: "M 18.5,53.5 C 21.935,54.1916 23.935,56.1916 24.5,59.5C 20.8333,59.1667 18.8333,57.1667 18.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#926c9e",
    d: "M 39.5,56.5 C 41.7288,57.0553 43.3954,58.3886 44.5,60.5C 41.2125,61.5683 39.5458,60.2349 39.5,56.5 Z"
  })), "\ns", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#946ea0",
    d: "M 28.5,67.5 C 30.7288,68.0553 32.3954,69.3886 33.5,71.5C 30.2125,72.5683 28.5458,71.2349 28.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#936da0",
    d: "M 22.5,73.5 C 26.2349,73.5458 27.5683,75.2125 26.5,78.5C 24.3886,77.3954 23.0553,75.7288 22.5,73.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Jewel100);
export default __webpack_public_path__ + "static/media/icons8-jewel-100.5e56dce7a924416214011b79020d1481.svg";
export { ForwardRef as ReactComponent };